import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

import type { UpdateSmartLabWeightSettingsRequest } from '@/lib/api/smartlab-weight-settings-api'
import { smartLabWeightSettingsApi } from '@/lib/api/smartlab-weight-settings-api'
import { m } from '@/lib/paraglide/messages'

export const smartLabWeightSettingsKeys = {
    all: ['smartlab-weight-settings'] as const,
}

export function useSmartLabWeightSettings() {
    return useQuery({
        queryKey: smartLabWeightSettingsKeys.all,
        queryFn: async () => {
            const res = await smartLabWeightSettingsApi.get()
            return res.data ?? null
        },
    })
}

export function useUpdateSmartLabWeightSettings() {
    const qc = useQueryClient()
    return useMutation({
        mutationFn: async (data: UpdateSmartLabWeightSettingsRequest) => {
            const res = await smartLabWeightSettingsApi.update(data)
            return res.data
        },
        onSuccess: () => {
            void qc.invalidateQueries({
                queryKey: smartLabWeightSettingsKeys.all,
            })
            toast.success(m.smartlab_weight_settings_save_success())
        },
        onError: () => toast.error(m.smartlab_weight_settings_save_error()),
    })
}
